export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6390.51ec18b4.jpg";